import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

/**
 * @file TriggerGroup
 */
import { getDefaultElementBoundary } from '@tencent/glue-util-boundary';
import { guid } from '@tencent/glue-util-helper';
export var TriggerGroup = /*#__PURE__*/function () {
  function TriggerGroup(popper) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var triggerId = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, TriggerGroup);

    this.activeTrigger = '';
    this.parent = null;
    this.triggerMap = {};
    this.disposed = false;
    this.popper = popper;
    this.parent = parent;
    this.id = triggerId || guid();
    this.init();
  }

  _createClass(TriggerGroup, [{
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getRect",
    value: function getRect() {
      var trigger = this.triggerMap[this.activeTrigger];

      if (trigger == null) {
        return getDefaultElementBoundary();
      }

      return trigger.getRect();
    }
  }, {
    key: "getData",
    value: function getData() {
      var trigger = this.triggerMap[this.activeTrigger];

      if (trigger == null) {
        return null;
      }

      return trigger.getData();
    }
  }, {
    key: "getTriggerType",
    value: function getTriggerType() {
      var trigger = this.triggerMap[this.activeTrigger];

      if (trigger == null) {
        return 'manual';
      }

      return trigger.getTriggerType();
    }
  }, {
    key: "getDisableToggleClose",
    value: function getDisableToggleClose() {
      var trigger = this.triggerMap[this.activeTrigger];

      if (trigger == null) {
        return false;
      }

      return trigger.getDisableToggleClose();
    }
  }, {
    key: "isTriggerFixed",
    value: function isTriggerFixed() {
      var trigger = this.triggerMap[this.activeTrigger];

      if (trigger == null) {
        return false;
      }

      return trigger.isTriggerFixed();
    }
  }, {
    key: "setActiveShow",
    value: function setActiveShow(show) {
      var trigger = this.triggerMap[this.activeTrigger];

      if (trigger == null) {
        return;
      }

      trigger.setActiveShow(show);
    }
  }, {
    key: "setActiveTrigger",
    value: function setActiveTrigger(triggerId) {
      var trigger = this.triggerMap[triggerId];

      if (!trigger) {
        return;
      }

      if (this.activeTrigger !== triggerId) {
        this.triggerMap[this.activeTrigger] && this.triggerMap[this.activeTrigger].setActiveShow(false);
      }

      this.activeTrigger = triggerId; // 设置父级的TG的activeTrigger

      if (this.parent) {
        this.parent.setActiveTrigger(this.id);
      }
    }
  }, {
    key: "cancelActiveTrigger",
    value: function cancelActiveTrigger(triggerId) {
      if (this.activeTrigger !== triggerId) {
        return;
      }

      this.activeTrigger = ''; // 清空父级的TG的activeTrigger

      if (this.parent) {
        this.parent.cancelActiveTrigger(this.id);
      }
    }
  }, {
    key: "getActiveTrigger",
    value: function getActiveTrigger() {
      return this.activeTrigger;
    }
  }, {
    key: "showPopper",
    value: function showPopper() {
      var trigger = this.triggerMap[this.activeTrigger];

      if (trigger == null) {
        return;
      }

      trigger.showPopper();
    }
  }, {
    key: "hidePopper",
    value: function hidePopper() {
      var trigger = this.triggerMap[this.activeTrigger];

      if (trigger == null) {
        return;
      }

      trigger.hidePopper();
    }
  }, {
    key: "isGroup",
    value: function isGroup() {
      return true;
    }
  }, {
    key: "getTriggerIdPath",
    value: function getTriggerIdPath() {
      var res = [this.id];

      if (!this.parent) {
        return res;
      }

      return this.parent.getTriggerIdPath().concat(res);
    }
  }, {
    key: "registerTrigger",
    value: function registerTrigger(trigger) {
      this.triggerMap[trigger.getId()] = trigger;
    }
  }, {
    key: "unregisterTrigger",
    value: function unregisterTrigger(trigger) {
      var triggerId = trigger.getId();

      if (this.triggerMap[triggerId]) {
        delete this.triggerMap[triggerId];
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var _this = this;

      if (this.disposed) {
        return;
      } // Group没用了，估计子类也没啥用了


      Object.keys(this.triggerMap).forEach(function (key) {
        _this.triggerMap[key] && _this.triggerMap[key].dispose();
      });

      if (this.parent) {
        this.parent.unregisterTrigger(this);
      }

      this.popper.unregisterTrigger(this);
      this.disposed = true;
    }
  }, {
    key: "init",
    value: function init() {
      if (this.parent) {
        this.parent.registerTrigger(this);
      }

      this.popper.registerTrigger(this);
    }
  }]);

  return TriggerGroup;
}();